/*
 * Module for the Participant Association Demographics Tab
*/

rs.module("participant/account/associations/edit/demographicstab",

    ["common/select-helper"],

    function (selectHelper) {

        var _jsSelectors;
        var _tab;
        var _disabilityCheckbox;
        var _studentCheckbox;

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            _jsSelectors = jsSelectors;
            _tab = $.js(jsSelectors.tab);
            _disabilityCheckbox = _tab.js(jsSelectors.disabilityCheckbox, { required: false });
            _studentCheckbox = _tab.js(jsSelectors.studentCheckbox, { required: false });

            // register checkbox change events
            _disabilityCheckbox.change(_toggleDisability);
            _studentCheckbox.change(_toggleStudent);
        }

        //
        // Toggle disability fields based on disability checkbox
        //
        function _toggleDisability() {

            var checked = _disabilityCheckbox.is(":checked");
            var disabilityTypeHelper = selectHelper.getHelper(_tab.js(_jsSelectors.disabilityTypeDropdown));

            disabilityTypeHelper.setDisabled(!checked);
            _tab.js(_jsSelectors.disabilityDatePicker).prop("disabled", !checked);

            if (!checked) {
                disabilityTypeHelper.setValue("");
            }
        }

        //
        // Toggle full time student fields based on full time student checkbox
        //
        function _toggleStudent() {

            var checked = _studentCheckbox.is(":checked");
            var studentDatePicker = _tab.js(_jsSelectors.studentDatePicker)

            studentDatePicker.prop("disabled", !checked);

            if (!checked) {
                studentDatePicker.val("");
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);